module.exports = __webpack_public_path__ + "assets/img/reheat_active.6088d36e.png";